var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-page"},[_c('Page',{staticClass:"xpage myPage",attrs:{"current":_vm.page.pageNo,"page-size":_vm.page.pageSize,"total":_vm.page.total},on:{"on-change":_vm.pageChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }